import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "invisible_box",
			"data-name": "invisible box",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 48,
				fill: "none"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Q3_icons",
			"data-name": "Q3 icons",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M39.6,18.7l.9-.2,3.3-.4A7.5,7.5,0,0,0,44,16a7.5,7.5,0,0,0-.2-2.1l-3.3-.4-.9-.2L39,11.9l.5-.8,2-2.7a13.3,13.3,0,0,0-2.9-2.9l-2.7,2-.8.5-1.4-.6-.2-.9-.4-3.3A7.5,7.5,0,0,0,31,3a7.5,7.5,0,0,0-2.1.2l-.4,3.3-.2.9L26.9,8l-.8-.5-2.7-2a13.3,13.3,0,0,0-2.9,2.9l2,2.7.5.8-.6,1.4-.9.2-3.3.4A7.5,7.5,0,0,0,18,16a7.5,7.5,0,0,0,.2,2.1l3.3.4.9.2.6,1.4-.5.8-2,2.7a13.3,13.3,0,0,0,2.9,2.9l2.7-2,.8-.5,1.4.6.2.9.4,3.3A7.5,7.5,0,0,0,31,29a7.5,7.5,0,0,0,2.1-.2l.4-3.3.2-.9,1.4-.6.8.5,2.7,2a13.3,13.3,0,0,0,2.9-2.9l-2-2.7-.5-.8ZM31,20a4,4,0,1,1,4-4A4,4,0,0,1,31,20Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M16,35v6H8V35h8m2-4H6a2,2,0,0,0-2,2V43a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V33a2,2,0,0,0-2-2Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M18,7h0a2,2,0,0,0-2-2H6A2,2,0,0,0,4,7V25a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H8V9h8A2,2,0,0,0,18,7Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M36,33v8H28V33a2,2,0,0,0-2-2h0a2,2,0,0,0-2,2V43a2,2,0,0,0,2,2H38a2,2,0,0,0,2-2V33a2,2,0,0,0-2-2h0A2,2,0,0,0,36,33Z" })
			]
		})]
	})
});
export default SvgDashboard;
